/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Social_Google_ConnectingInputs */

const en_auth_social_google_connecting = /** @type {(inputs: Auth_Social_Google_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting to Google...`)
};

const es_auth_social_google_connecting = /** @type {(inputs: Auth_Social_Google_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando con Google...`)
};

/**
* | output |
* | --- |
* | "Connecting to Google..." |
*
* @param {Auth_Social_Google_ConnectingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_social_google_connecting = /** @type {((inputs?: Auth_Social_Google_ConnectingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Social_Google_ConnectingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_social_google_connecting(inputs)
	return es_auth_social_google_connecting(inputs)
});